/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";
  var booking_id = [];
  var booking_free58 = [];
  var booking_free80 = [];
  var booking_paper58 = [];
  var booking_paper80 = [];
  var booking_total = [];

  var check = function check() {
    $f7.request({
      method: 'get',
      url: window.waypointGEN + 'json/checkpaper.aspx',
      data: {
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);

        if (data.free != "0") {
          if (window.lang == "en") $(".block-free").html("\n          You will get your FREE 58mm Ticket Paper (" + data.free + "/50)<br/>\n          You will get your FREE 80mm Ticket Paper (" + data.free + "/100)\n          ");
          if (window.lang == "cn") $(".block-free").html("\n          \u60A8\u5C06\u83B7\u5F97\u514D\u8D39\u7684 58mm \u7968\u7EB8 (" + data.free + "/50)<br/>\n          \u60A8\u5C06\u83B7\u5F97\u514D\u8D39\u7684 80mm \u7968\u7EB8 (" + data.free + "/100)\n          ");
          if (window.lang == "tl") $(".block-free").html("\n          Ita boot sei hetan surat-tahan ne'eb\xE9 livre 58mm ticket (" + data.free + "/50)<br/>\n          Ita boot sei hetan surat-tahan ne'eb\xE9 livre 80mm ticket (" + data.free + "/100)\n          ");
        }

        $("#freepaper58").html("<option value='0'>0</option>");
        $("#freepaper80").html("<option value='0'>0</option>");
        $("#paper58").html("<option value='0'>0</option>");
        $("#paper80").html("<option value='0'>0</option>");

        for (var i = 0; i < parseInt(data.free); i++) {
          $("#freepaper58").append("<option value='" + (i + 1) + "'>" + (i + 1) + "</option>");
          $("#freepaper80").append("<option value='" + (i + 1) + "'>" + (i + 1) + "</option>");
        }

        for (var i = 0; i < parseInt(data.buy); i++) {
          $("#paper58").append("<option value='" + (i + 1) + "'>" + (i + 1) + "</option>");
          $("#paper80").append("<option value='" + (i + 1) + "'>" + (i + 1) + "</option>");
        }

        for (var b = 0; b < data.booking.length; b++) {
          booking_id[b] = data.booking[b].orderID;
          booking_free58[b] = data.booking[b].receipt[0].qty;
          booking_free80[b] = data.booking[b].receipt[1].qty;
          booking_paper58[b] = data.booking[b].receipt[2].qty;
          booking_paper80[b] = data.booking[b].receipt[3].qty;
          booking_total[b] = data.booking[b].total;
          receipt += "\n          <tr>\n            <td class=\"label-cell\">" + data.booking[b].orderID + "</td>\n            <td class=\"numeric-cell\"><button id='" + b + "' class='button button-fill button-view'>view</button></td>\n          </tr>\n          ";
        }

        $update();
        $(document).on("click", ".button-view", function (e) {
          console.log(e.srcElement.id);
          var no = parseInt(e.srcElement.id);
          preview(booking_id[no], booking_free58[no], booking_free80[no], booking_paper58[no], booking_paper80[no], booking_total[no]);
        });
      }
    });
  };

  var preview = function preview(id, free58, free80, paper58, paper80, total) {
    window.print_qr = id;
    window.print_hide_button = "true";
    window.print_detail = "\n    <div class=\"card data-table\">\n    <table>\n      <thead>\n        <tr>\n          <th class=\"label-cell\">Free Paper</th>\n          <th class=\"numeric-cell\">Quantity</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td class=\"label-cell\">Free 58 mm</td>\n          <td class=\"numeric-cell\">" + free58 + "</td>\n        </tr>\n        <tr>\n          <td class=\"label-cell\">Free 80 mm</td>\n          <td class=\"numeric-cell\">" + free80 + "</td>\n        </tr>\n      </tbody>\n    </table>\n    </div>\n    <div class=\"card data-table\">\n    <table>\n      <thead>\n        <tr>\n          <th class=\"label-cell\">Buy Paper</th>\n          <th class=\"numeric-cell\">Quantity</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr>\n          <td class=\"label-cell\">Buy 58 mm</td>\n          <td class=\"numeric-cell\">" + paper58 + "</td>\n        </tr>\n        <tr>\n          <td class=\"label-cell\">Buy 80 mm</td>\n          <td class=\"numeric-cell\">" + paper80 + "</td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"card data-table\">\n    <div class=\"data-table-footer\">\n      <H1 style=\"margin-right:16px\">TOTAL: $" + total + "</H1> \n    </div>\n  </div>\n  <div class=\"block\">\n    <center>\n      Please present the QR to cashier\n    </center>\n  </div>\n    ";
    $f7.views.main.router.navigate("/GEN_receipt/");
  };

  var order = function order() {
    var url_paper = "";
    if (window.wallet == "true") url_paper = "json/walletPaper.aspx";else url_paper = 'json/bookpaper.aspx';

    if ($("#paper58").val() == "0" && $("#paper80").val() == "0" && $("#freepaper58").val() == "0" && $("#freepaper80").val() == "0") {
      $f7.dialog.alert("Please select the quantity of paper");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.waypointGEN + url_paper,
      data: {
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        paper58: $("#paper58").val(),
        paper80: $("#paper80").val(),
        free58: $("#freepaper58").val(),
        free80: $("#freepaper80").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        data = data.replace(",\"{", ",{");
        var data = JSON.parse(data);
        console.log(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          window.paper_58 = $("#paper58").val();
          window.paper_80 = $("#paper80").val();
          window.paper_free58 = $("#freepaper58").val();
          window.paper_free80 = $("#freepaper80").val();
          window.print_text = "{CENTER}";
          window.print_text += "{BR}{BR}";
          window.print_text += "{BR}Buy Paper 58mm:" + $("#paper58").val();
          window.print_text += "{BR}Buy Paper 80mm:" + $("#paper80").val();
          window.print_text += "{BR}Free Paper 58mm:" + $("#freepaper58").val();
          window.print_text += "{BR}Free Paper 80mm:" + $("#freepaper80").val();
          window.print_text += "{BR}{BR} TOTAL : $" + data.total;
          window.print_text += "{BR}{BR}";
          window.print_qr = data.orderId; //window.print_barcode = data.orderId;

          window.print_hide_button = "true";
          window.print_detail = "\n            <div class=\"card data-table\">\n            <table>\n              <thead>\n                <tr>\n                  <th class=\"label-cell\">Free Paper</th>\n                  <th class=\"numeric-cell\">Quantity</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td class=\"label-cell\">Free 58 mm</td>\n                  <td class=\"numeric-cell\">" + $("#freepaper58").val() + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Free 80 mm</td>\n                  <td class=\"numeric-cell\">" + $("#freepaper80").val() + "</td>\n                </tr>\n              </tbody>\n            </table>\n            </div>\n            <div class=\"card data-table\">\n            <table>\n              <thead>\n                <tr>\n                  <th class=\"label-cell\">Buy Paper</th>\n                  <th class=\"numeric-cell\">Quantity</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td class=\"label-cell\">Buy 58 mm</td>\n                  <td class=\"numeric-cell\">" + $("#paper58").val() + "</td>\n                </tr>\n                <tr>\n                  <td class=\"label-cell\">Buy 80 mm</td>\n                  <td class=\"numeric-cell\">" + $("#paper80").val() + "</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"card data-table\">\n            <div class=\"data-table-footer\">\n              <H1 style=\"margin-right:16px\">TOTAL: $" + data.total + "</H1> \n            </div>\n          </div>\n          <div class=\"block\">\n            <center>\n              Please present the QR to cashier\n            </center>\n          </div>\n            ";
          $f7.views.main.router.navigate("/GEN_receipt/");
        } else {
          $f7.dialog.alert(data.errmsg);
        }
      }
    });
  };

  $on('pageInit', function () {
    $("#orderId").focus();
    check();
    $('.wallet-amount').html("$" + window.wallet_amount);

    if (window.wallet == "true") {
      $(".wallet-off").hide();
      $(".wallet-on").show();
    } else {
      $(".wallet-off").show();
      $(".wallet-on").hide();
    }

    $("#freepaper58").change(function () {
      $("#freepaper80").val("0");
    });
    $("#freepaper80").change(function () {
      $("#freepaper58").val("0");
    });
    $("#paper58").change(function () {
      $("#paper80").val("0");
    });
    $("#paper80").change(function () {
      $("#paper58").val("0");
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Buy Ticket</span>
        <span class='cn'>买票</span>
        <span class='tl'>Sosa Ticket</span>
      </div>
    </div>
  </div>
  <div class="page-content">


    <div class="data-table card wallet-on" style="background-color: var(--f7-theme-color);">
      <div class="card-content ">
        <table>
          <thead>
          <th >e-Wallet Amount</th>
          <th class="numeric-cell wallet-amount" style="font-size: 20px; color: white;"></th>
          </thead>
          <tbody>
          </tbody>  
        </table>
      </div>
    </div>

    <div class="block-title wallet-off">
      <span class='en'>Free Paper</span>
      <span class='cn'>免费纸</span>
      <span class='tl'>Gratis Surat-tahan</span>
    </div>
    <div class="block block-free wallet-off">
      
    </div>
    <div class="list  inline-labels inset wallet-off">
      <ul>  
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Free 58 mm</span>
              <span class='cn'>免费 58 mm</span>
              <span class='tl'>Gratis 58 mm</span>
            </div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select placeholder="Please choose..." id="freepaper58">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Free 80 mm</span>
              <span class='cn'>免费 80 mm</span>
              <span class='tl'>Gratis 80 mm</span>
            </div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select placeholder="Please choose..." id="freepaper80">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
        </li>
        
      </ul>
    </div>

    <div class="block-title">
      <span class='en'>Buy Paper</span>
      <span class='cn'>买纸</span>
      <span class='tl'>Hola Surat-tahan</span>
    </div>

    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Buy 58 mm</span>
              <span class='cn'>买 58 mm</span>
              <span class='tl'>Hola 58 mm</span>
            </div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select placeholder="Please choose..." id="paper58">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Buy 80 mm</span>
              <span class='cn'>买 80 mm</span>
              <span class='tl'>Hola 80 mm</span>
            </div>
            <div class="item-input-wrap input-dropdown-wrap">
              <select placeholder="Please choose..." id="paper80">
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </select>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="list  inline-labels inset">
      <ul>    
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click="${order}">
              <span class='en'>Order</span>
              <span class='cn'>现在下单</span>
              <span class='tl'>Hameno</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
      </ul>
    </div>

    
    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Pending Claim</th>
            <th class="numeric-cell">Receipt</th>
          </tr>
        </thead>
        <tbody innerHTML=${receipt}>

        </tbody>
      </table>
      
    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '8a9a0a460c';
export default framework7Component;